/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Direction
 */
export type CreateExchangeSubAccountTransferRequestDirection = typeof CreateExchangeSubAccountTransferRequestDirection[keyof typeof CreateExchangeSubAccountTransferRequestDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateExchangeSubAccountTransferRequestDirection = {
  CREDIT: 'CREDIT',
  DEBIT: 'DEBIT',
  NONE: 'NONE',
} as const;
